const add = a => b => a + b;
const sub = a => b => b - a;
const div = a => b => b / a;
const mul = a => b => a * b;
const flip = fn => a => b => fn(b)(a);
const toNumber = data => Number(data);

const arithmeticOperations = {
  '*': mul,
  '+': add,
  '/': flip(div),
  '-': flip(sub),
};

const orderOfOperation = [
  ['*', '/'],
  ['+', '-'],
];

const solveArithmetic = arithmetic => {
  const [number1, operation, number2] = arithmetic.split(/(\*|\+|-|\/)/);
  return arithmeticOperations[operation](toNumber(number1))(toNumber(number2));
};

// recursively evaluate expression like 1+2+3, 1/2/2/3, 1*3/3/4*4-2 etc with respecting order of operation
export const evaluateMath = expression => {
  orderOfOperation.forEach(operation => {
    const newOperation = operation.map(o => `${'\\' + o}`).join('|');
    const regex = new RegExp(`[0-9]+(\\.[0-9]+)*(${newOperation})[0-9]+(\\.[0-9]+)?`, 'g');
    if (expression.match(regex)) {
      expression = expression.replace(regex, solveArithmetic);
      return evaluateMath(expression);
    }
  })
  return toNumber(expression);
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/util/arithmetic.js